var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTettraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 85,
    r: 81,
    fill: "white",
    stroke: "#233C85",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 37,
    width: 100,
    height: 100,
    fill: "url(#pattern0_313_30)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_313_30",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_313_30",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_313_30",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAq1BMVEX///8bGhkAsvOv6v/7+/tWVVWysbEvLi0iMjgBq+kSW3UdHBsHiLeSwtIcHh+Ojo0YZ4Sp4fUcJCZDQkLr6+tpaGccLTMoRlBLZm/Pz84OYoB5nqsEmtBplKN6eXkmJSRXb3cVSFo6TlULdZwiOkJRcn6e0uRdhJEVQFCAqLY5OTjd3d2cm5vAv79AW2Q6R0sbVGgGkcPZ2NiJtMNMS0vJyMiXl5Y6UlsuPEBxrb9tAAAFCklEQVR4nO2b63ayOhCGsYCiEZBwErEgqHio2tZ+dvf+r2yjJogcNMTPdK+18/7yTzLPTCbJZGgFgYuLi4uLS5Ca629OJB0CuZnsQG8fPOuKQrK8Q1sP7IZTBQdJ8MxWcwFg2nrGkFrXbRMAiolMT5Bpxh0VmrK+tSTJ2uqyGVJOAmShQwuQjl7L+n6vy+sHpugI1GPPE5gmvfWTHgR4XL8PgHPAUQgFIahOeAAgJJ1EcdCYjoDXcNAn1ujDcbSiec1xJ/6XSqo5AjAFGwO8EKs77vejovmdryaGSKwFArCFAG3hjy45wctLf5a3/j58VRsYP2p3HhoGQrtz/rlsAjByLlkAnEVT66JovJ8Hd9rC2xolYZ/c/hRm9oEyaW5eFL+U8/D1m2DJaKYRcQj6SuY+nPjNracBmCAPZEuQAjSXSxqCsZv5r8U07ouiOkETBOl99o2mg1NCgFFmH84TGvPpHkAxBN/pZZrdx+6YbAFg5v+cyv00AC6aIb2NBcHCJ4FGFILPGcDpR+u/+ArxKWAdywm8EYl24riH/Vd8Sv9FI27hTXgqabI1gARpOF0+Gn9R9PEuOq1AGgIdBzW6mwXjpZblP639JMb2dFTTZSHQBvcWYYQzUKG2Ly606wCkaajjLFDuLMIlAxfU9v0fnAG6hYtqD2+EewfyFC+ASx0AFR9jwMYByG8ErXcrDbp4CzgTavtzvABoC6BFCHAI4K1EHKNLWNvRngDJDicRCCwhJy8rbsGNAxEfggrdDXC8AzIzppe3ny7CGh8wIKrLg+4HGr6js2+o/2TXyLpdeGBKm8sV70yrd+MYVZIa3RYw/EsZAzalB+7evhQ5s34lQR8BOCs6+3FmANj78tvas7MHHoBR1cU0BShLKFIw8WMl8zC0vaoXvpWLQQuOSlHAmxA034PG1wRe5j5fghXaB7lHLnCiwefVhuhGiK1hFZZ8LYY/Od/CoBx/HAP9+skD3TQOqRDAEm9CYscNQ1UX7uxqUqDX+H8i2Fy/9IEGlSjq9aZHDVAO/tQAJOpqtXrNabEYxulT7sqp0NzcsH+MwZ/Cuy9lwE8+dIjGFTloJF+rxTyO3wvvSK04259b/h8lvdmd1m3FxWPIUP2dW34tVqhjv9U0uPIIGzm82XQonIOJP0w9JbAOQrl8/FQSWPrNjtMwD6D6MxLjp76WbhHZPyLs23Z93+kCYKiLQo7VKTTt9p7U/EmWp9e1fzIAw3eJrAPT1L07uVe1EF4ahqoeGgYgiz7opM57xMG/QpAk69D+DnAnFQcEAaziYvQ1nIvAxJ3Q4Lt9sGp7u6Qc1lm4bjsD+Mq1deikx2Z0/t1poyGPWS6C5AGSiZK/uWA06I8v11WnWG38dQA1f7m1ZvjmZAaQTJxclrnT7LpiBJDk/IfKdFyqGJ4NkMu/tG6pKFmeDPCT5R9Qris3RgAXFQt41gCl8p0tAIhKzwe2AEr58cAUoKqrxxIAjsr2mQIsq16wDAGq26rsALTqJgIzADCrbqoyA4A1rX1mABVHAFuAuu9LrAC02iYSIwDn83cBgFtjnxWAVnUKswSo/7jECqC2oc0IYFb7UYERQP2nJUYA0f8eoMcBOAAH4AAcgANwAA7AATjAbwPMBrWaMQEAWq0AE4D74gBPAtiu75s+a719BkD2B8D3JTf+UEwkaSuHgECh/JwAHL9nb3QCbai+VBMiPPBfSFxcXFxc/1X9C9ZYk6T4EZ9vAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTettraLogo);
export default __webpack_public_path__ + "static/media/tettraLogo.0b7b1e47414d444fd7741cd554874376.svg";
export { ForwardRef as ReactComponent };